// extracted by mini-css-extract-plugin
export default {"container":"timer-pill_container__14QHW","inner":"timer-pill_inner__10X6J","timer":"timer-pill_timer__2dHge","defisTheme":"timer-pill_defisTheme__66Kpa"};